import { h } from 'preact'
import { HintContent } from 'src/common/types'
import { HintContentListView } from '../HintContentListView'
import close from './close.svg'
import './styles.scss'

const stopPropagation = (e: Event) => {
  e.stopPropagation()
}

export const ModalView = (props: {
  contents?: HintContent[]
  onClose?: () => void
}) => {
  const { contents } = props

  if (!contents || contents.length === 0) {
    return null
  }

  return (
    <div className="modal_bg" onClick={props.onClose}>
      <div id="online_dialog" onClick={stopPropagation}>
        <div className="modal_close_container">
          <button id="online_dialog_close" onClick={props.onClose}>
            <img src={close} alt="閉じる" />
          </button>
        </div>
        <div>
          <HintContentListView contents={contents ?? []} idPrefix="modal" />
        </div>
      </div>
    </div>
  )
}
